import { Pill } from '@mantine/core';

import { SourceType } from '@/module/Author/Publication/model/PublicationTypes';

export interface SourceProps {
  source: {
    type: SourceType;
  };
}

function Wos() {
  return (
    <Pill
      bg="blue"
      c="white"
    >
      WoS
    </Pill>
  );
}

function Scopus() {
  return (
    <Pill
      bg="blue"
      c="white"
    >
      Scopus
    </Pill>
  );
}

export function Source({ source }: SourceProps) {
  if (source?.type == 'WOS') {
    return <Wos />;
  }

  if (source?.type == 'SCOPUS') {
    return <Scopus />;
  }
  return <Pill>{source?.type}</Pill>;
}
